import { Chip, Link, SxProps } from '@mui/material';

import { useGetPrimaryPolicyDocumentQuery } from '../../api/documents/getPrimaryPolicyDocument';
import IDCardIcon from '../../assets/icons/FAQ/IDCard';
import PaperIcon from '../../assets/icons/Paper';
import colors, { csaaBlack, csaaMid } from '../../constants/colors';

interface ChipProps extends React.PropsWithChildren {
  disabled?: boolean;
  labelText: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  policyNumber?: string;
  policyType?: string;
  sx: SxProps;
  testId?: string;
}

export const DocumentChip = ({
  disabled,
  labelText,
  onClick,
  policyNumber,
  policyType,
  sx,
  testId,
}: ChipProps) => {
  const {
    data: primaryPolicyDocumentDataUri,
    isLoading,
    isError,
  } = useGetPrimaryPolicyDocumentQuery(policyNumber, policyType);

  // const fileName = `${labelText}-${policyNumber}`;

  const Icon = policyType === 'AUTO' ? <IDCardIcon /> : <PaperIcon />;

  if (!primaryPolicyDocumentDataUri || isError || isLoading) {
    return null;
  }

  return (
    <Chip
      component={Link}
      href={primaryPolicyDocumentDataUri}
      target="_blank"
      icon={Icon}
      label={labelText}
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderColor: csaaBlack,
        borderRadius: 6,
        height: '28px',
        my: 3,
        '& .MuiChip-label': {
          pl: 0.5,
          pr: 0,
          color: csaaMid,
          fontFamily: 'Cabin',
          fontWeight: 400,
          fontSize: 14,
          letterSpacing: '0.2px',
        },
        '&:focus': {
          border: `2px solid ${colors.csaaBlack}`,
          borderRadius: 6,
          outline: 'unset',
          color: 'inherit',
          backgroundColor: 'inherit',
        },
        '&:hover': {
          textDecoration: 'none',
        },
        ...sx,
      }}
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
    />
  );
};
